export enum DateRange {
  YESTERDAY = 'YESTERDAY',
  TODAY = 'TODAY',
  PAST_WEEK = 'PAST_WEEK',
  PAST_TWO_WEEKS = 'PAST_TWO_WEEKS',
  PAST_THREE_WEEKS = 'PAST_THREE_WEEKS',
  TRIMESTER = 'TRIMESTER',
  YEAR = 'YEAR',
  TWO_YEAR = 'TWO_YEAR',
}
